/* UMI&UMI — 首单15%优惠 侧边条+弹窗(四语言,跟随站点语言)
   行为:未领取者右侧边缘常驻竖条;首访 2 秒后自动弹一次;点击竖条再弹;
   领取(复制+静默应用 /discount/HELLO15)后永久隐藏;关闭仅收回竖条。 */
(function () {
  if (window.__umiPromo) return; window.__umiPromo = true;
  var CODE = 'HELLO15';
  var LS_CLAIMED = 'umi_promo_claimed';
  try { if (localStorage.getItem(LS_CLAIMED)) return; } catch (e) { return; }
  if (navigator.webdriver === true && /bot|crawl|spider/i.test(navigator.userAgent)) return;

  var cfg = window.__umiPromoCfg || {};
  if (cfg.code) CODE = cfg.code;
  var L = (document.documentElement.lang || 'ja');
  var T = {
    ja:   { tab: '15% OFF', title: 'はじめまして、UMI&UMIです', sub: '初回のご注文が15%オフ',
            hint: 'チェックアウトで自動適用されます', btn: 'コードをコピーして適用', done: 'コピーしました ✓ 自動適用されます' },
    en:   { tab: '15% OFF', title: 'Welcome to UMI&UMI', sub: '15% off your first order',
            hint: 'Applied automatically at checkout', btn: 'Copy code & apply', done: 'Copied ✓ applied at checkout' },
    ko:   { tab: '15% OFF', title: '처음 오셨나요? UMI&UMI입니다', sub: '첫 주문 15% 할인',
            hint: '결제 시 자동으로 적용됩니다', btn: '코드 복사하고 적용', done: '복사 완료 ✓ 자동 적용됩니다' },
    'zh-CN': { tab: '15% OFF', title: '初次见面,UMI&UMI', sub: '首单立享 15% 折扣',
            hint: '结账时自动生效', btn: '复制优惠码并应用', done: '已复制 ✓ 结账自动生效' }
  };
  var t = T[L] || T.ja;
  /* 客户在主题设置里改过的字段优先(与日语默认值不同才覆盖;保持默认=四语言内置文案) */
  var DEF = T.ja;
  ['title','sub','btn','done','hint'].forEach(function (k) {
    if (cfg[k] && cfg[k] !== DEF[k]) t[k] = cfg[k];
  });

  var css = [
    '.umi-promo-tab{position:fixed;right:0;top:50%;transform:translateY(-50%);z-index:9990;',
    ' writing-mode:vertical-rl;text-orientation:mixed;letter-spacing:.14em;',
    ' background:#c6a568;color:#2b2b2b;font:700 12px/1 var(--font-body--family,system-ui,sans-serif);',
    ' padding:16px 9px;border-radius:8px 0 0 8px;cursor:pointer;border:none;',
    ' box-shadow:0 4px 16px rgba(120,95,45,.3);transition:background .2s,padding .2s;}',
    '.umi-promo-tab:hover{background:#b8965a;padding-right:13px;}',
    '.umi-promo-mask{position:fixed;inset:0;background:rgba(30,25,18,.45);z-index:9991;',
    ' opacity:0;transition:opacity .3s;pointer-events:none;}',
    '.umi-promo-mask.open{opacity:1;pointer-events:auto;}',
    '.umi-promo-pop{position:fixed;left:50%;top:50%;transform:translate(-50%,-50%) scale(.94);z-index:9992;',
    ' width:340px;max-width:calc(100vw - 32px);background:#fdfbf7;border-radius:14px;overflow:hidden;',
    ' box-shadow:0 20px 60px rgba(0,0,0,.3);opacity:0;pointer-events:none;',
    ' transition:opacity .32s,transform .32s cubic-bezier(.2,.7,.3,1);}',
    '.umi-promo-pop.open{opacity:1;pointer-events:auto;transform:translate(-50%,-50%) scale(1);}',
    '.umi-promo-head{background:#c6a568;padding:26px 24px 22px;text-align:center;position:relative;}',
    '.umi-promo-head .big{font:700 34px/1 var(--font-heading--family,Georgia,serif);color:#2b2b2b;letter-spacing:.02em;}',
    '.umi-promo-close{position:absolute;top:10px;right:10px;width:28px;height:28px;border:none;border-radius:50%;',
    ' background:rgba(43,43,43,.14);color:#2b2b2b;font-size:16px;line-height:28px;cursor:pointer;padding:0;}',
    '.umi-promo-close:hover{background:rgba(43,43,43,.28);}',
    '.umi-promo-body{padding:20px 24px 24px;text-align:center;color:#2b2b2b;}',
    '.umi-promo-body h3{margin:0 0 6px;font:400 19px/1.35 var(--font-heading--family,Georgia,serif);}',
    '.umi-promo-body .sub{margin:0 0 14px;font:600 13.5px/1.5 var(--font-body--family,system-ui,sans-serif);}',
    '.umi-promo-code{display:inline-block;border:1.5px dashed #c6a568;border-radius:8px;padding:9px 22px;',
    ' font:700 17px/1 ui-monospace,Consolas,monospace;letter-spacing:.18em;margin-bottom:14px;background:#fff;}',
    '.umi-promo-btn{display:block;width:100%;border:none;border-radius:9px;padding:13px 0;cursor:pointer;',
    ' background:#2b2b2b;color:#fff;font:600 13.5px/1 var(--font-body--family,system-ui,sans-serif);',
    ' transition:background .2s,transform .2s;}',
    '.umi-promo-btn:hover{background:#454540;transform:translateY(-1px);}',
    '.umi-promo-btn.done{background:#3d7a4e;}',
    '.umi-promo-hint{margin:10px 0 0;font-size:11.5px;color:#9a9182;}',
    '@media (max-width:749px){',
    ' .umi-promo-tab{padding:13px 7px;font-size:11px;}}'
  ].join('');
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var tab = document.createElement('button');
  tab.className = 'umi-promo-tab'; tab.type = 'button';
  tab.setAttribute('aria-label', t.sub); tab.textContent = t.tab;

  var mask = document.createElement('div'); mask.className = 'umi-promo-mask';
  var pop = document.createElement('div');
  pop.className = 'umi-promo-pop'; pop.setAttribute('role', 'dialog'); pop.setAttribute('aria-label', t.sub);
  pop.innerHTML =
    '<div class="umi-promo-head"><button class="umi-promo-close" aria-label="close">×</button>' +
    '<div class="big">15% OFF</div></div>' +
    '<div class="umi-promo-body"><h3>' + t.title + '</h3><p class="sub">' + t.sub + '</p>' +
    '<div class="umi-promo-code notranslate" translate="no">' + CODE + '</div>' +
    '<button class="umi-promo-btn" type="button">' + t.btn + '</button>' +
    '<p class="umi-promo-hint">' + t.hint + '</p></div>';

  function mount () {
    document.body.appendChild(tab); document.body.appendChild(mask); document.body.appendChild(pop);
    var open = function () {
      pop.classList.add('open'); mask.classList.add('open'); tab.style.display = 'none';
      document.cookie = 'umi_promo_seen=1; path=/; SameSite=Lax';
    };
    var close = function () {
      pop.classList.remove('open'); mask.classList.remove('open'); tab.style.display = '';
      document.cookie = 'umi_promo_seen=1; path=/; SameSite=Lax';   /* 会话 cookie,不设过期 */
    };
    tab.addEventListener('click', open);
    mask.addEventListener('click', close);
    pop.querySelector('.umi-promo-close').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    var btn = pop.querySelector('.umi-promo-btn');
    btn.addEventListener('click', function () {
      // 复制
      var copied = false;
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(CODE); copied = true;
        }
      } catch (e) {}
      if (!copied) {
        try {
          var ta = document.createElement('textarea'); ta.value = CODE;
          ta.style.cssText = 'position:fixed;opacity:0'; document.body.appendChild(ta);
          ta.select(); document.execCommand('copy'); ta.remove();
        } catch (e) {}
      }
      // 静默应用折扣(Shopify /discount/CODE 会写入结账 cookie)
      try { fetch('/discount/' + CODE, { credentials: 'same-origin' }); } catch (e) {}
      btn.textContent = t.done; btn.classList.add('done');
      try { localStorage.setItem(LS_CLAIMED, '1'); } catch (e) {}
      setTimeout(function () {
        pop.classList.remove('open'); mask.classList.remove('open');
        tab.remove();                       // 已领取:侧边条永久消失
      }, 1600);
    });

    // 本次浏览器会话内只自动弹一次(会话 cookie:关闭浏览器后重开才会再次自动弹)
    var seen = /(?:^|; )umi_promo_seen=1/.test(document.cookie);
    var delay = (typeof cfg.delay === 'number') ? cfg.delay * 1000 : 2200;
    if (!seen && delay > 0) setTimeout(open, delay);
  }
  if (document.body) mount();
  else document.addEventListener('DOMContentLoaded', mount);
})();
